import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { Meta } from '@angular/platform-browser';
import { navigationViews, UpdateService } from '../../../services/update.service';

export interface AboutUsPersonDetail {

}

@Component({
	selector: 'about-us',
	templateUrl: 'about-us.html',
	styleUrls: ['about-us.scss']
})

export class AboutUsComponent implements OnInit {
	@ViewChildren('personPopper') personPoppers: QueryList<any>;

	public people: string[];

	constructor(
		private _updateService: UpdateService,
		private _meta: Meta
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'});

		this.people = [
			`Brenna focuses on vegetable crop production and contributes to
				CropManage by assisting with grower consultations and trainings.`,
			`Khaled leads irrigation and water resource management and plays a
				central role in CropManage's outreach and funding efforts. He is
				actively involved in grower consultations and trainings.`,
			`Mae specializes in the horticulture of tree crops and contributes
				to CropManage through algorithm development and testing for tree
				crop applications, as well as grower consultations and trainings.`,
			`Daniel contributes to CropManage through data collection for
				processing tomato models and the development of nitrogen
				mineralization models for organic amendments, crop residues, and
				organic fertilizers.`,
			`Lee contributes to CropManage through field testing and validation
				of vegetable crop models, OpenET and satellite imagery, and
				evapotranspiration measurements.`,
			`Forrest contributes to CropManage through field testing and
				validation of vegetable crop models, OpenET and satellite imagery,
				and evapotranspiration measurements.`,
			`Aliasghar contributed to CropManage through model development for
				alfalfa, avocado, carrot, and leafy greens, along with field
				testing and validation, and grower consultations and trainings.`,
			`Joji contributes to CropManage through the development of nitrogen
				mineralization models for organic amendments, crop residues, and
				organic fertilizers.`,
			`Richard contributes to CropManage through nitrogen uptake curves for
				vegetables and field testing and validation of fertilizer
				nitrogen models.`,
			`Zheng works in vegetable crop production and irrigation management.
				He contributes to CropManage through data collection, algorithm
				development, and field testing for tomato and melon crops, and
				participates in grower consultations and trainings.`,
			`Daniele contributes to CropManage through irrigation scheduling
				model development for citrus crops and evapotranspiration measurements.`,
			`Mohammad specializes in tree crop production and contributes to
				CropManage through field data collection for citrus crops, as
				well as grower consultations and trainings.`,
			`David is a field staff member who supports CropManage through field
				data collection, sensor installation and maintenance, grower
				consultations, and trainings.`,
			`Jorge is a field staff member who supports CropManage through field
				data collection, sensor installation and maintenance, grower
				consultations, and trainings. He also provides Spanish-language
				outreach and trainings.`,
			`Noe is a field staff member who supports CropManage through field
				data collection, sensor installation and maintenance, grower
				consultations, and trainings. He also provides Spanish-language
				outreach and trainings.`,
			`Larry contributed to CropManage as a specialist in winegrape model development.`,
			`Andre works in irrigation and water resource management, contributing
				to CropManage through data collection, algorithm development,
				and field testing for berry and vegetable crops. He also
				participates in grower consultations and trainings.`,
			`Patrick contributed to CropManage through the development of the
				fertilizer nitrogen model for almond, pistachio, walnut, pear,
				and prune.`,
			`Tim contributed to CropManage through the development of the fertilizer
				nitrogen model for vegetables and strawberries.`,
			`Joy focuses on table grape production and contributes to CropManage
				through field testing and validation, as well as grower consultations
				and trainings.`,
			`Kenneth contributes to CropManage through water quality regulations,
				citrus model development, and grower outreach.`,
			`Shijian specializes in wine, table, and raisin grape production.
				He contributes to CropManage through data collection, field
				testing, and grower consultations and trainings.`,
		];
	}

	ngOnInit(): void {
		this._updateService.setCurrentPage(navigationViews.ABOUT_US);
	}
}
